import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NDA_COPIES, NDA_ICON, NdaStatus } from 'models/Nda';
import usePastTime from 'hooks/usePastTime';
import ResolvePopup from 'components/ResolvePopup';
import { isNdaRejected } from 'utils';
import TruncatedText from 'components/TruncatedText';
import TransWithNda from 'components/TransWithNda';

import './NdaStatusBadge.styles.scss';

type NdaStatusBadgeProps = {
  className?: string;
  status: NdaStatus;
  sentDate?: Date;
  signedDate?: Date;
  rejectionReason?: string;
  envelopeTemplateName: string;
  envelopeTemplatePopupName?: string;
};

const NdaStatusBadge: React.FC<NdaStatusBadgeProps> = (props) => {
  const {
    className,
    status,
    sentDate,
    signedDate,
    rejectionReason,
    envelopeTemplateName,
    envelopeTemplatePopupName = envelopeTemplateName,
  } = props;

  const classes = classNames('nda-status-badge', status, className);

  const Icon = useMemo(() => NDA_ICON[status], [status]);

  const pastTime = usePastTime();

  const { t } = useTranslation();

  return (
    <ResolvePopup
      onHover
      className="nda-status-badge-popup"
      popupContent={
        <div className="nda-status-badge-popup__content">
          <TransWithNda
            className="nda-status-copy"
            i18nKey={NDA_COPIES[status]}
            envelopeTemplateName={envelopeTemplatePopupName}
            disableTooltip
          />

          {isNdaRejected(status) ? (
            rejectionReason && <p>{rejectionReason}</p>
          ) : signedDate ? (
            <p>{pastTime(signedDate)}</p>
          ) : (
            sentDate && <p>{pastTime(sentDate)}</p>
          )}
        </div>
      }
    >
      <div className={classes}>
        {envelopeTemplateName ? (
          <TruncatedText text={envelopeTemplateName} disableTooltip />
        ) : (
          t('NDA')
        )}
        <Icon />
      </div>
    </ResolvePopup>
  );
};

export default NdaStatusBadge;
